import * as React from 'react';

/**
 * A type of an object that have a route key as an object key
 * and a value whether to prevent that route.
 */

export const PreventRemoveContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=PreventRemoveContext.js.map